import {
  GALLERY_CLEAR_SEARCH_PARAMETERS,
  GALLERY_FETCH_PA_AGREEMENTS,
  GALLERY_RESULTS_AVAILABLE,
  GALLERY_SET_ASSET_TYPE_AND_FAMILY,
  GALLERY_SET_SEARCH_PARAMETER,
  GALLERY_TOGGLE_SEARCH_PARAMETER,
  GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES,
  GALLERY_FETCH_MORE_EVENTS,
  GALLERY_FETCH_MORE_GATEWAY_ASSETS,
} from 'app/actions/types';
import * as agreementService from 'app/services/agreementsService';
import * as galleryService from 'app/services/galleryService';
import * as editorialLandingService from 'app/services/editorialLandingService';
import { pageActions, searchPreferencesActions } from 'app/actions';
import { PageView } from 'app/views';
import prepareGalleryResults from 'app/support/prepareGalleryResults';

export const fetchPaAgreementsInfo = () => async (dispatch) => {
  const paAgreements = await agreementService.getPaAgreementInfo();
  dispatch({
    type: GALLERY_FETCH_PA_AGREEMENTS,
    paAgreements,
  });
};

export const fetchMoreEvents = (params) => async (dispatch) => {
  dispatch(pageActions.pageStatusChanged(PageView.LOADING));

  const events = await editorialLandingService.getEvents(params);
  dispatch(pageActions.pageStatusChanged(PageView.LOADED));
  dispatch({
    type: GALLERY_FETCH_MORE_EVENTS,
    events,
  });
};

export const clearSearchParameters = () => ({
  type: GALLERY_CLEAR_SEARCH_PARAMETERS,
});

export const galleryResultsAvailable = (gallery) => ({
  type: GALLERY_RESULTS_AVAILABLE,
  gallery,
});

export const search =
  (path, pushState = true) =>
  async (dispatch) =>
    new Promise((resolve) => {
      setTimeout(async () => {
        const { searchPreferences, ...gallery } = await galleryService.search(
          path,
          pushState
        );
        const galleryResults = prepareGalleryResults(gallery);

        dispatch(galleryResultsAvailable(galleryResults));
        dispatch(
          searchPreferencesActions.searchPreferencesAvailable(searchPreferences)
        );

        resolve(gallery);
      }, 0);
    });

export const setSearchParameter = (parameter, value, siteNickname) => ({
  type: GALLERY_SET_SEARCH_PARAMETER,
  parameter,
  value,
  siteNickname,
});

export const setAssetTypeAndFamily = (assetType, family) => ({
  type: GALLERY_SET_ASSET_TYPE_AND_FAMILY,
  assetType,
  family,
});

export const toggleSearchParameter = (parameter) => ({
  type: GALLERY_TOGGLE_SEARCH_PARAMETER,
  parameter,
});

export const toggleSearchParameterValues = (parameter, values) => ({
  type: GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES,
  parameter,
  values,
});

export const fetchMoreGatewayAssets = (url) => async (dispatch) => {
  dispatch(pageActions.pageAssetsLoading(true));

  // .getSearch returns a new galley state without pushing the url to history as opposed to .search
  const newState = await galleryService.getSearch(url);
  const { assets } = newState.gallery;
  const pageNum = newState.gallery.page;

  dispatch(pageActions.pageAssetsLoading(false));
  dispatch(setSearchParameter('page', pageNum));
  dispatch({
    type: GALLERY_FETCH_MORE_GATEWAY_ASSETS,
    assets,
  });
};

export const updateSearchResults = (searchResults) => (dispatch) => {
  const { searchPreferences, ...gallery } = searchResults;

  const galleryResults = prepareGalleryResults(gallery);

  dispatch(galleryResultsAvailable(galleryResults));
  dispatch(
    searchPreferencesActions.searchPreferencesAvailable(searchPreferences)
  );

  return galleryResults;
};
